module.exports = __webpack_public_path__ + "img/io-9.859e3d14.jpg";